import { dataProps, itemListProps } from './properties'

export const setInventoryStockCheckList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
    state.nav.had_results = payload.total>0
    }
}    

export const setInventoryStockCheckData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addNewInventoryStockCheckItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('item_id_'+(key-1)).focus()
    }, 300);

}

export const removeInventoryStockCheckItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetInventoryStockCheckData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setInventoryStockCheckItemListRow = (state, payload) => {

    let key = 0
    state.props.item_list = payload

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryStockCheck/mutations.js